// extracted by mini-css-extract-plugin
export var about = "about-module--about--H9dbg";
export var divider = "about-module--divider--9IVSs";
export var experience = "about-module--experience--SsscX";
export var hobbies = "about-module--hobbies--Ztjku";
export var subdivider = "about-module--subdivider--yzPJU";
export var trail = "about-module--trail--adI4+";